import moment from 'moment';
import { getGlobalStore } from '../pages/AppStore';

const filters = {
    // Context Path를 포함한 URL 생성
    ctxPath(path) {
        const store = getGlobalStore(); // 전역 스토어 가져오기
        const contextPath = store.state.contextPath || '';
        return contextPath + path;
    },

    // Context Path를 제외한 URL 생성
    logicalPath(path) {
        const store = getGlobalStore(); // 전역 스토어 가져오기
        const contextPath = store.state.contextPath || '';
        return (contextPath !== '' && path.startsWith(contextPath)) ? path.slice(contextPath.length) : path;
    },

    // 아이디 정규식(5~20자의 영문 소문자, 숫자와 특수기호(_),(-)만 사용)
    date(value) {
        return moment(value).format('YYYY-MM-DD');
    },

    // 아이디 정규식(5~20자의 영문 소문자, 숫자와 특수기호(_),(-)만 사용)
    dateTime(value) {
        return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },

    bytesToSize(bytes) {

        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

        if (bytes == 0) return '0 Byte';

        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));

        return Math.trunc((bytes / Math.pow(1024, i)) * 10) / 10 + ' ' + sizes[i];

    },

    // 일자 표기 (YYYYMMDD -> YYYY-MM-DD)
    ymd(value) {
        if (!value || value.length !== 8) return value ?? '';
        return value.substring(0, 4) + '-' + value.substring(4, 6) + '-' + value.substring(6, 8);
    },

    // 일자 전송값 (YYYY-MM-DD -> YYYYMMDD)
    ymdParam(value) {
        if (!value) return '';
        return value.replace(/-/g, '');
    },

    // 시분 표기 (HHMM -> HH:MM)
    hm(value) {
        if (!value || value.length !== 4) return value ?? '';
        return value.substring(0, 2) + ':' + value.substring(2, 4);
    },

    // 시분 전송값 (HH:MM -> HHMM)
    hmParam(value) {
        if (!value) return '';
        return value.replace(/:/g, '');
    },

    // 일자 기간 표기 (YYYY-MM-DD ~ YYYY-MM-DD)
    ymdRange(bgngYmd, endYmd) {
        return filters.ymd(bgngYmd) + ' ~ ' + filters.ymd(endYmd);
    },

    // 시분 기간 표기 (HH:MM ~ HH:MM)
    hmRange(bgngHm, endHm) {
        return filters.hm(bgngHm) + ' ~ ' + filters.hm(endHm);
    },

    // 연락처 표기 (01012345678 -> 010-1234-5678)
    // 저장값에 '-'가 섞여 있어도 숫자만 뽑아 다시 넣는다. 아는 형태가 아니면 원본을 그대로 돌려준다.
    tel(value) {
        if (!value) return '';
        const n = String(value).replace(/[^0-9]/g, '');
        // 1588-1234 같은 대표번호는 지역번호가 없다
        if (n.length == 8) return n.slice(0, 4) + '-' + n.slice(4);
        // 서울(02)만 지역번호가 2자리
        const head = n.startsWith('02') ? 2 : 3;
        const body = n.length - head - 4; // 국번 자리수
        if (body < 3 || body > 4) return value;
        return n.slice(0, head) + '-' + n.slice(head, head + body) + '-' + n.slice(-4);
    },

    // 사업자등록번호 표기 (1234567890 -> 123-45-67890)
    brno(value) {
        if (!value) return '';
        const n = String(value).replace(/[^0-9]/g, '');
        if (n.length !== 10) return value;
        return n.slice(0, 3) + '-' + n.slice(3, 5) + '-' + n.slice(5);
    },

    // 예약·신청 승인상태 코드 -> 뱃지 클래스 (공통코드 RSVT_APRV_STTS)
    // 관리자 목록과 사용자 마이페이지가 같은 색을 쓰도록 한 곳에서 매핑한다.
    // 반환값에 'hide' 를 쓰지 말 것 — 전역 `.hide { display:none !important }` 에 걸려 뱃지가 사라진다.
    sttsCls(cd) {
        return {
            // 예약·신청 승인상태 (RSVT_APRV_STTS)
            RAS_WTNG: 'wtng',   // 대기
            RAS_APRV: 'aprv',   // 승인
            RAS_RJCT: 'rjct',   // 반려
            RAS_RTRCN: 'rtrcn', // 취소
            // 시설 운영상태 (FCLT_STTS)
            FS_RSVT_PSBLTY: 'psblty', // 예약가능
            FS_RSVT_IMPS: 'imps',     // 예약불가
            FS_HIDE: 'off',           // 숨김
            // 장비 운영상태 (EQPMNT_STTS)
            ES_RSVT_PSBLTY: 'psblty', // 예약가능
            ES_RSVT_IMPS: 'imps',     // 예약불가
            ES_HIDE: 'off',           // 숨김
            // 세미나 운영상태 (SMNR_STTS)
            SS_APLY_PSBLTY: 'psblty', // 신청가능
            SS_APLY_IMPS: 'imps',     // 신청불가
            SS_HIDE: 'off',           // 숨김
            // 사업 진행상태 (BIZ_STTS)
            BS_BFR: 'wtng',           // 사업진행전
            BS_PRGRS: 'psblty',       // 사업진행중
            BS_END: 'off',            // 사업종료
            BS_MDWY_EXPRY: 'imps',    // 사업중도만료
            // 사업신청상태 (BIZ_APLY_STTS)
            BAS_WTNG: 'wtng',         // 신청대기
            BAS_PSBLTY: 'psblty',     // 신청가능
            BAS_DDLN: 'off',          // 신청마감 (기간이 끝난 것이므로 BS_END 와 같은 회색)
        }[cd] ?? 'wtng';
    },

    // 운영요일 표기 (monYn ~ sunYn 을 가진 객체 -> ['월','화',...])
    operDays(data) {
        if (!data) return [];
        const days = [
            { key: 'monYn',  nm: '월' },
            { key: 'tueYn',  nm: '화' },
            { key: 'wedYn',  nm: '수' },
            { key: 'thurYn', nm: '목' },
            { key: 'friYn',  nm: '금' },
            { key: 'satYn',  nm: '토' },
            { key: 'sunYn',  nm: '일' }
        ];
        return days.filter(day => data[day.key] === 'Y').map(day => day.nm);
    },

    //  파일명 확장자 제거
    removeExtension(value) {
        // 마지막 '.'의 위치
        const lastIndex = value.lastIndexOf('.');

        // '.'이 없으면 원본 문자열을 반환
        if (lastIndex === -1) return value;

        // '.' 이전까지의 문자열을 반환
        return value.substring(0, lastIndex);
    }
}

export default filters;